export const ChevronProgressSectionDown = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6.50003L8.00002 10.5L12 6.5"
      stroke="#4A5466"
      strokeMiterlimit="16"
    />
  </svg>
);
